import type { ReactNode } from 'react';
import { Icon } from './Icon.js';

export function EmptyState({
  icon = 'inbox',
  title,
  body,
}: {
  icon?: string;
  title: string;
  body?: string;
}) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '64px 24px',
        color: 'var(--text-3)',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          width: 52,
          height: 52,
          borderRadius: 14,
          background: 'var(--bg-sunken)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 14,
        }}
      >
        <Icon name={icon} size={24} />
      </div>
      <div style={{ fontWeight: 700, color: 'var(--text-2)', fontSize: 15 }}>{title}</div>
      {body && <div style={{ marginTop: 4, fontSize: 13, maxWidth: 320 }}>{body}</div>}
    </div>
  );
}

export function PageHeader({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        gap: 16,
        marginBottom: 4,
      }}
    >
      <div>
        <h1 style={{ margin: 0, fontSize: 24, fontWeight: 900, letterSpacing: '-0.02em', lineHeight: 1.15 }}>
          {title}
        </h1>
        {/* Fern Green section underrule (brand). */}
        <div
          aria-hidden="true"
          style={{ width: 36, height: 3, borderRadius: 2, background: 'var(--jfh-fern-green)', margin: '9px 0' }}
        />
        {subtitle && <div style={{ color: 'var(--text-2)', fontSize: 14 }}>{subtitle}</div>}
      </div>
      {actions && <div style={{ display: 'flex', gap: 9, flex: 'none' }}>{actions}</div>}
    </div>
  );
}

export function Avatar({ name, size = 28 }: { name: string; size?: number }) {
  const init = (name || '?')
    .split(' ')
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: 99,
        flex: 'none',
        background: 'var(--jfh-pistachio)',
        color: 'var(--jfh-mountain-green)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: size * 0.38,
        fontWeight: 800,
        letterSpacing: '0.02em',
      }}
    >
      {init}
    </div>
  );
}
